





















































import {Component, Vue} from 'vue-property-decorator'
import Carga from '@/model/resource/Carga'
import { ID } from 'simpli-web-sdk'
import ItAudit from '@/components/itrack/ItAudit.vue'
import {AppConfig} from '@/config/app.config'
import PhotoSlider from '@/components/PhotoSlider.vue'
import ItRender from '@/components/itrack/ItRender.vue'

@Component({
  components: {PhotoSlider, ItAudit, ItRender},
})
export default class ModalAudit extends Vue {
  carga: Carga | null = null

  AppConfig = AppConfig

  async openEvent(idCarga: ID) {
    this.$emit('open')
    this.carga = new Carga()
    await this.carga.find(idCarga, 'getCargaAudit')
  }

  closeEvent() {
    this.carga = null
    this.$emit('close')
  }

  close() {
    this.$modal.close('modalAudit')
  }

  async submit() {
    const audit = this.$refs.audit as ItAudit
    await audit.persistAuditoria()
    this.close()
    this.$emit('success')
  }

  topValue(top: string) {
    return this.carga && this.carga.fotosOcorrencia.length > 0 && this.carga.fotosComprovantes.length > 0 ? top : '1rem'
  }
}
